import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ConsumableOverview = React.lazy(() => import('.'));

export const consumableOverviewRoutes = [
  new Route({
    path: 'consumable-overview',
    element: ConsumableOverview,
    children: [],
  }),
];
